import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV } from "../../lib/site";
import { DemoDialog } from "./DemoDialog";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [pathname]);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled || open ? "bg-[#0E1117]/92 backdrop-blur-xl border-b border-white/8" : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-[68px] flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5 group">
          <img src="/partecon-mark.png" alt="PARTECON" className="h-8 w-auto group-hover:scale-105 transition-transform" />
          <span className="font-display text-[17px] font-semibold tracking-[0.14em] text-white">PARTECON</span>
        </Link>

        <div className="hidden lg:flex items-center gap-7">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`nav-link-${n.to.slice(1)}`}
              className={`text-[13.5px] font-medium link-underline pb-0.5 transition-colors ${
                pathname === n.to ? "text-white" : "text-white/55 hover:text-white"
              }`}
            >
              {n.label}
            </Link>
          ))}
        </div>

        <div className="hidden lg:block">
          <DemoDialog>
            <button data-testid="nav-demo-btn" className="btn-primary px-5 py-2.5 text-[13.5px]">Request a Demo</button>
          </DemoDialog>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-white p-2"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <div data-testid="nav-mobile-menu" className="lg:hidden bg-[#0E1117]/98 backdrop-blur-xl border-t border-white/10 px-5 py-6 flex flex-col gap-4">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} className={`text-base flex items-center gap-2 ${pathname === n.to ? "text-white" : "text-white/55 hover:text-white"}`} data-testid={`nav-mobile-${n.to.slice(1)}`}>
              {pathname === n.to && <span className="h-1.5 w-1.5 rounded-full bg-[#6366F1]" />}{n.label}
            </Link>
          ))}
          <DemoDialog>
            <button className="btn-primary px-5 py-3 text-sm mt-2 w-full">Request a Demo</button>
          </DemoDialog>
        </div>
      )}
    </header>
  );
};
